/**
 * [AI補完仕様] このコメントはAI補完（コード自動生成）に構造情報として渡されます。変更時は実装品質に直結するため正確に保つこと。
 *
 * 現在ログイン中ユーザー情報を提供するコンテキスト。
 *
 * @contract useCurrentUser()はログイン後のコンポーネント内でのみ使用可能（ProtectedRoute配下）。
 * @contract rolesは文字列配列。ロール判定には roles.includes() を使うこと。単数形の role プロパティは存在しない。
 * @contract ワークフロー遷移APIへのリクエストにロール情報を含める必要はない（バックエンドがJWTから取得する）。
 * @signature useCurrentUser(): { roles: string[], displayName: string, id: string }
 * @signature CurrentUserProvider: React.Provider<{ roles, displayName, id }>
 */
import { createContext, useContext } from 'react'

interface CurrentUser {
  roles: string[]
  displayName: string
  id: string
}

const CurrentUserContext = createContext<CurrentUser>({ roles: [], displayName: '', id: '' })

export const CurrentUserProvider = CurrentUserContext.Provider

export function useCurrentUser(): CurrentUser {
  return useContext(CurrentUserContext)
}